module.exports = __webpack_public_path__ + "img/logo.3a0d44d9.png";